export const diffColor = (
  quadrant,
  starsEgp: any,
  starsVerification: any
): string => {
  if (starsEgp[quadrant] === starsVerification[quadrant]) {
    return 'green';
  } else {
    return 'red';
  }
};
